export const FETCH_JOB_ALERTS_LIST_REQUEST = 'FETCH_JOB_ALERTS_LIST_REQUEST'
export const FETCH_JOB_ALERTS_LIST_SUCCESS = 'FETCH_JOB_ALERTS_LIST_SUCCESS'
export const FETCH_JOB_ALERTS_LIST_FAILED = 'FETCH_JOB_ALERTS_LIST_FAILED'
